import * as actionTypes from "../actions/actionTypes";
// import { deepCopy, updateObject } from '../../shared/utility';
import { doLog, hasValue, updateObject } from "../../shared/utility";

const initialState = {
  result: null,
  error: null,
  loading: false,
  transDesc: null,
  //
  reportList: null,
  reportListLoading: true,
  reportListErrorMsg: "",
  //
  reportResult: null,
  reportError: null,
  //
  upLoadNextIndex: 0,
  upLoadFileResult: null,
  upLoadFileError: null,
  //
  selectedIncidentTypeData: null,
  //
  multipleListLoading: false,
  //
  attachmentArray: [],
  attachmentSelectFieldList: null,
  attachmentTextFieldList: null,
  //
  personArray: [],
  personSelectFieldList: null,
  personTextFieldList: null,
  //
  personInvolvementList: null,
  //
  propertyArray: [],
  propertySelectFieldList: null,
  propertyTextFieldList: null,
  //
  propertyTypeList: null,
  propertyColorList: null,
  //
  vehicleArray: [],
  vehicleSelectFieldList: null,
  vehicleTextFieldList: null,
  //
  vehicleInvolvementList: null,
  vehicleBodyStyleList: null,
  vehicleMakeList: null,
  vehicleColorList: null,
  //
  agencyCode: null,
  configuration: null,
  configurationLoading: false,
  configurationErrorMsg: "",
  //
  raceList: null,
  sexList: null,
  ethnicityList: null,
  eyeColorList: null,
  hairColorList: null,
  stateList: null,
  countyList: null,
  citytwpList: null,
  //
  incidentTypeList: null,
  incidentTypeDataList: null,
  incidentTypeLoading: false,
  incidentTypeErrorMsg: "",
  //
  webAgencyList: null,
  //
  customTextArray: [],
  customTextList: null,
  customTextLoading: false,
  customTextErrorMsg: "",
  //
  incidentDetails: null,
  incidentDetailsLoading: false,
  incidentDetailsErrorMsg: "",
  //
  sharedIncidentDetails: null,
  //
  requiredFieldArray: [],
  requiredFieldList: null,
  requiredFieldLoading: false,
  requiredFieldErrorMsg: "",
  //
  defaultRequiredFieldList: null,
  defaultRequiredFieldLoading: false,
  defaultRequiredFieldErrorMsg: "",
  //
  baseURL: "",
  pathname: "",
};

//--------------------------------------------------------------------------------------
const runTransactionStart = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: true,
    result: action.result,
    transDesc: action.transDesc,
  });
};

const runTransactionSuccess = (state, action) => {
  if (doLog())
    console.log(
      "transactions_reducer.runTransactionSuccess result:",
      action.result
    );
  let result = action.result;
  let webAgencyList = state.webAgencyList;
  if (
    action.transDesc === "webAgencyList" &&
    action.result !== null &&
    hasValue(action.result.RESULT.CITIZENWEBAGENCY)
  ) {
    if (
      action.result.RESULT.CITIZENWEBAGENCY &&
      action.result.RESULT.CITIZENWEBAGENCY.length > 0
    ) {
      webAgencyList = action.result.RESULT.CITIZENWEBAGENCY;
    } else {
      //Make sure an array is returned.
      webAgencyList = [];
      webAgencyList.push(action.result.RESULT.CITIZENWEBAGENCY);
    }
    result = null;
  } else if (
    action.transDesc === "incidentTypeList" &&
    action.result !== null &&
    // !hasValue(action.result.RESULT.CITIZENINCIDENTTYPE) && hasValue(action.result.RESULT.@ENDOFFSET) && action.result.RESULT.@ENDOFFSET === "0") {
    !hasValue(action.result.RESULT.CITIZENINCIDENTTYPE)
  ) {
    const emptyRecord = { CITIZENINCIDENTTYPE: [] };
    result = { RESULT: emptyRecord };
    if (doLog())
      console.log(
        "transactions_reducer.runTransactionSuccess new result:",
        result
      );
  }

  return updateObject(state, {
    result: result,
    error: null,
    loading: false,
    transDesc: action.transDesc,
    webAgencyList: webAgencyList,
  });
};

const runTransactionFail = (state, action) => {
  return updateObject(state, {
    result: null,
    error: action.error,
    loading: false,
  });
};

const clearWebAgencyList = (state, action) => {
  return updateObject(state, {
    webAgencyList: null,
  });
};

const clearTransactionResult = (state, action) => {
  return updateObject(state, {
    result: null,
    error: null,
    loading: false,
  });
};

const clearTransDesc = (state, action) => {
  return updateObject(state, {
    transDesc: null,
  });
};

//------------------------------------------------------------------------------
const fetchIncidentTypeListStart = (state, action) => {
  return updateObject(state, {
    incidentTypeList: null,
    incidentTypeDataList: null,
    incidentTypeLoading: true,
    incidentTypeErrorMsg: "",
  });
};

const fetchIncidentTypeListSuccess = (state, action) => {
  return updateObject(state, {
    incidentTypeList: action.incidentTypeList,
    incidentTypeDataList: action.incidentTypeDataList,
    incidentTypeLoading: false,
    incidentTypeErrorMsg: "",
    personArray: [],
    propertyArray: [],
    vehicleArray: [],
    requiredFieldArray: [],
  });
};

const fetchIncidentTypeListFail = (state, action) => {
  if (doLog())
    console.log(
      "[fetchIncidentTypeListFail] action.ErrorMsg:",
      action.ErrorMsg
    );
  return updateObject(state, {
    incidentTypeList: null,
    incidentTypeDataList: null,
    incidentTypeLoading: false,
    incidentTypeErrorMsg: action.ErrorMsg,
  });
};

//------------------------------------------------------------------------------
const addToCustomTextArray = (state, action) => {
  // if (doLog()) console.log("[addToCustomTextArray reducers] state:", state);
  if (doLog())
    console.log("[addToCustomTextArray reducers] item:", action.item);
  const newArray = [...state.customTextArray];
  newArray.push(action.item);
  return updateObject(state, {
    customTextArray: newArray,
  });
};

const setCustomTextArray = (state, action) => {
  return updateObject(state, {
    customTextArray: action.customTextArray,
  });
};

const clearIncidentDetails = (state, action) => {
  return updateObject(state, { incidentDetails: null });
};

const fetchIncidentDetailsStart = (state, action) => {
  return updateObject(state, {
    incidentDetails: null,
    incidentDetailsLoading: true,
    incidentDetailsErrorMsg: "",
  });
};

const fetchIncidentDetailsSuccess = (state, action) => {
  return updateObject(state, {
    incidentDetails: action.incidentDetails,
    incidentDetailsLoading: false,
    incidentDetailsErrorMsg: "",
  });
};

const fetchIncidentDetailsFail = (state, action) => {
  if (doLog())
    console.log("[fetchIncidentDetailsFail] action.ErrorMsg:", action.ErrorMsg);
  return updateObject(state, {
    incidentDetails: null,
    incidentDetailsLoading: false,
    incidentDetailsErrorMsg: action.ErrorMsg,
  });
};

const setSharedIncidentDetails = (state, action) => {
  return updateObject(state, {
    sharedIncidentDetails: action.sharedIncidentDetails,
  });
};

const clearCustomTextList = (state, action) => {
  return updateObject(state, { customTextList: null });
};

const fetchCustomTextListStart = (state, action) => {
  return updateObject(state, {
    customTextList: null,
    customTextLoading: true,
    customTextErrorMsg: "",
  });
};

const fetchCustomTextListSuccess = (state, action) => {
  return updateObject(state, {
    customTextList: action.customTextList,
    customTextLoading: false,
    customTextErrorMsg: "",
  });
};

const fetchCustomTextListFail = (state, action) => {
  if (doLog())
    console.log("[fetchCustomTextListFail] action.ErrorMsg:", action.ErrorMsg);
  return updateObject(state, {
    customTextList: null,
    customTextLoading: false,
    customTextErrorMsg: action.ErrorMsg,
  });
};

//------------------------------------------------------------------------------
const addToRequiredFieldArray = (state, action) => {
  // if (doLog()) console.log("[addToRequiredFieldArray reducers] item:", action.item);
  const newArray = [...state.requiredFieldArray];
  newArray.push(action.item);
  return updateObject(state, {
    requiredFieldArray: newArray,
  });
};

const setRequiredFieldArray = (state, action) => {
  return updateObject(state, {
    requiredFieldArray: action.requiredFieldArray,
  });
};

const clearRequiredFieldList = (state, action) => {
  return updateObject(state, { requiredFieldList: null });
};

const fetchRequiredFieldListStart = (state, action) => {
  return updateObject(state, {
    requiredFieldList: null,
    requiredFieldLoading: true,
    requiredFieldErrorMsg: "",
  });
};

const fetchRequiredFieldListSuccess = (state, action) => {
  return updateObject(state, {
    requiredFieldList: action.requiredFieldList,
    requiredFieldLoading: false,
    requiredFieldErrorMsg: "",
  });
};

const fetchRequiredFieldListFail = (state, action) => {
  if (doLog())
    console.log(
      "[fetchRequiredFieldListFail] action.ErrorMsg:",
      action.ErrorMsg
    );
  return updateObject(state, {
    requiredFieldList: action.requiredFieldList,
    requiredFieldLoading: false,
    requiredFieldErrorMsg: action.ErrorMsg,
  });
};

//------------------------------------------------------------------------------
const fetchDefaultRequiredFieldListStart = (state, action) => {
  return updateObject(state, {
    defaultRequiredFieldList: null,
    defaultRequiredFieldLoading: true,
    defaultRequiredFieldErrorMsg: "",
  });
};

const fetchDefaultRequiredFieldListSuccess = (state, action) => {
  return updateObject(state, {
    defaultRequiredFieldList: action.defaultRequiredFieldList,
    defaultRequiredFieldLoading: false,
    defaultRequiredFieldErrorMsg: "",
  });
};

const fetchDefaultRequiredFieldListFail = (state, action) => {
  if (doLog())
    console.log(
      "[fetchDefaultRequiredFieldListFail] action.ErrorMsg:",
      action.ErrorMsg
    );
  return updateObject(state, {
    defaultRequiredFieldList: null,
    defaultRequiredFieldLoading: false,
    defaultRequiredFieldErrorMsg: action.ErrorMsg,
  });
};

//------------------------------------------------------------------------------
const fetchConfigurationStart = (state, action) => {
  return updateObject(state, {
    configuration: null,
    configurationLoading: true,
    configurationErrorMsg: "",
  });
};

const fetchConfigurationSuccess = (state, action) => {
  return updateObject(state, {
    agencyCode: action.agencyCode,
    configuration: action.configuration,
    configurationLoading: false,
    configurationErrorMsg: "",
  });
};

const fetchConfigurationFail = (state, action) => {
  if (doLog())
    console.log("[fetchConfigurationFail] action.ErrorMsg:", action.ErrorMsg);
  return updateObject(state, {
    configuration: null,
    configurationLoading: false,
    configurationErrorMsg: action.ErrorMsg,
  });
};

//------------------------------------------------------------------------------
const clearValidCodeList = (state, action) => {
  if (doLog())
    console.log(
      "[clearValidCodeList.reducers] action.listName:",
      action.listName
    );
  let resultObj = null;
  if (action.listName === "vehicleInvolvementList")
    resultObj = { vehicleInvolvementList: null };
  else if (action.listName === "vehicleBodyStyleList")
    resultObj = { vehicleBodyStyleList: null };
  else if (action.listName === "vehicleMakeList")
    resultObj = { vehicleMakeList: null };
  else if (action.listName === "vehicleColorList")
    resultObj = { vehicleColorList: null };
  else if (action.listName === "propertyTypeList")
    resultObj = { propertyTypeList: null };
  else if (action.listName === "propertyColorList")
    resultObj = { propertyColorList: null };
  //
  else if (action.listName === "raceList") resultObj = { raceList: null };
  else if (action.listName === "sexList") resultObj = { sexList: null };
  else if (action.listName === "ethnicityList") resultObj = { ethnicityList: null };
  else if (action.listName === "eyeColorList")
    resultObj = { eyeColorList: null };
  else if (action.listName === "hairColorList")
    resultObj = { hairColorList: null };
  else if (action.listName === "stateList") resultObj = { stateList: null };
  else if (action.listName === "personInvolvementList")
    resultObj = { personInvolvementList: null };
  //
  else if (action.listName === "countyList") resultObj = { countyList: null };
  else if (action.listName === "citytwpList") resultObj = { citytwpList: null };

  return updateObject(state, resultObj);
};

const fetchValidCodeListsStart = (state, action) => {
  if (doLog())
    console.log("[fetchValidCodeListsStart] action.listName:", action.listName);
  let resultObj = null;
  if (action.listName === "vehicleInvolvementList")
    resultObj = { vehicleInvolvementList: null };
  // else if (action.listName === 'vehicleStateCodeList') resultObj = { vehicleStateCodeList: null };
  else if (action.listName === "vehicleBodyStyleList")
    resultObj = { vehicleBodyStyleList: null };
  else if (action.listName === "vehicleMakeList")
    resultObj = { vehicleMakeList: null };
  else if (action.listName === "vehicleColorList")
    resultObj = { vehicleColorList: null };
  else if (action.listName === "propertyTypeList")
    resultObj = { propertyTypeList: null };
  else if (action.listName === "propertyColorList")
    resultObj = { propertyColorList: null };
  //
  else if (action.listName === "raceList") resultObj = { raceList: null };
  else if (action.listName === "sexList") resultObj = { sexList: null };
  else if (action.listName === "ethnicityList") resultObj = { ethnicityList: null };
  else if (action.listName === "eyeColorList")
    resultObj = { eyeColorList: null };
  else if (action.listName === "hairColorList")
    resultObj = { hairColorList: null };
  else if (action.listName === "stateList") resultObj = { stateList: null };
  else if (action.listName === "personInvolvementList")
    resultObj = { personInvolvementList: null };
  //
  else if (action.listName === "countyList") resultObj = { countyList: null };
  else if (action.listName === "citytwpList") resultObj = { citytwpList: null };

  return updateObject(state, resultObj);
};

const fetchValidCodeListsSuccess = (state, action) => {
  if (doLog())
    console.log(
      "[fetchValidCodeListsSuccess.reducers] action.listName:",
      action.listName
    );
  if (doLog())
    console.log(
      "[fetchValidCodeListsSuccess.reducers] action.list:",
      action.list
    );
  let resultObj = null;
  if (action.listName === "vehicleInvolvementList")
    resultObj = { vehicleInvolvementList: action.list };
  // else if (action.listName === 'vehicleStateCodeList') resultObj = { vehicleStateCodeList: action.list };
  else if (action.listName === "vehicleBodyStyleList")
    resultObj = { vehicleBodyStyleList: action.list };
  else if (action.listName === "vehicleMakeList")
    resultObj = { vehicleMakeList: action.list };
  else if (action.listName === "vehicleColorList")
    resultObj = { vehicleColorList: action.list };
  else if (action.listName === "propertyTypeList")
    resultObj = { propertyTypeList: action.list };
  else if (action.listName === "propertyColorList")
    resultObj = { propertyColorList: action.list };
  //
  else if (action.listName === "raceList")
    resultObj = { raceList: action.list };
  else if (action.listName === "sexList") resultObj = { sexList: action.list };
  else if (action.listName === "ethnicityList") resultObj = { ethnicityList: action.list };
  else if (action.listName === "eyeColorList")
    resultObj = { eyeColorList: action.list };
  else if (action.listName === "hairColorList")
    resultObj = { hairColorList: action.list };
  else if (action.listName === "stateList")
    resultObj = { stateList: action.list };
  else if (action.listName === "personInvolvementList")
    resultObj = { personInvolvementList: action.list };
  //
  else if (action.listName === "countyList")
    resultObj = { countyList: action.list };
  else if (action.listName === "citytwpList")
    resultObj = { citytwpList: action.list };

  return updateObject(state, resultObj);
};

const fetchValidCodeListsFail = (state, action) => {
  if (doLog())
    console.log(
      "[fetchIncidentTypeListFail] action.ErrorMsg:",
      action.ErrorMsg
    );
  let resultObj = null;
  if (action.listName === "vehicleInvolvementList")
    resultObj = { vehicleInvolvementList: null };
  // else if (action.listName === 'vehicleStateCodeList') resultObj = { vehicleStateCodeList: null };
  else if (action.listName === "vehicleBodyStyleList")
    resultObj = { vehicleBodyStyleList: null };
  else if (action.listName === "vehicleMakeList")
    resultObj = { vehicleMakeList: null };
  else if (action.listName === "vehicleColorList")
    resultObj = { vehicleColorList: null };
  else if (action.listName === "propertyTypeList")
    resultObj = { propertyTypeList: null };
  else if (action.listName === "propertyColorList")
    resultObj = { propertyColorList: null };
  //
  else if (action.listName === "raceList") resultObj = { raceList: null };
  else if (action.listName === "sexList") resultObj = { sexList: null };
  else if (action.listName === "ethnicityList") resultObj = { ethnicityList: null };
  else if (action.listName === "eyeColorList")
    resultObj = { eyeColorList: null };
  else if (action.listName === "hairColorList")
    resultObj = { hairColorList: null };
  else if (action.listName === "stateList") resultObj = { stateList: null };
  else if (action.listName === "personInvolvementList")
    resultObj = { personInvolvementList: null };
  //
  else if (action.listName === "countyList") resultObj = { countyList: null };
  else if (action.listName === "citytwpList") resultObj = { citytwpList: null };

  return updateObject(state, resultObj);
};

const fetchMultipleValidCodeListsStart = (state, action) => {
  if (doLog())
    console.log("[fetchValidCodeListsStart] action.listName:", action.listName);
  return updateObject(state, {
    multipleListLoading: true,
  });
};

const fetchMultipleValidCodeListsSuccess = (state, action) => {
  if (doLog())
    console.log(
      "[fetchMultipleValidCodeListsSuccess.reducers] action.listName:",
      action.listName
    );

    return updateObject(state, {
      multipleListLoading: false,
    });
    };

const fetchMultipleValidCodeListsFail = (state, action) => {
  if (doLog())
    console.log(
      "[fetchMultipleValidCodeListsFail] action.ErrorMsg:",
      action.ErrorMsg
    );
    
    return updateObject(state, {
      multipleListLoading: false,
    });
  };

//------------------------------------------------------------------------------
const setAgencyCode = (state, action) => {
  return updateObject(state, {
    agencyCode: action.agencyCode,
  });
};

const setConfigurationDefaults = (state, action) => {
  return updateObject(state, {
    configuration: action.configuration,
  });
};

const setIncidentTypeData = (state, action) => {
  return updateObject(state, {
    selectedIncidentTypeData: action.selectedIncidentTypeData,
  });
};

const setServerInfo = (state, action) => {
  return updateObject(state, {
    baseURL: action.baseURL,
    pathname: action.pathname,
  });
};

//--------------------------------------------------------------------------------------
const addToAttachmentArray = (state, action) => {
  return updateObject(state, {
    attachmentArray: action.attachmentArray,
  });
};

const deleteFromAttachmentArray = (state, action) => {
  return updateObject(state, {
    attachmentArray: action.attachmentArray,
  });
};

const setAttachmentArray = (state, action) => {
  return updateObject(state, {
    attachmentArray: action.attachmentArray,
  });
};

const setAttachmentSelectFieldList = (state, action) => {
  return updateObject(state, {
    attachmentSelectFieldList: action.attachmentSelectFieldList,
  });
};

const setAttachmentTextFieldList = (state, action) => {
  return updateObject(state, {
    attachmentTextFieldList: action.attachmentTextFieldList,
  });
};
//--------------------------------------------------------------------------------------
const addToPersonArray = (state, action) => { 
  return updateObject(state, {
    personArray: action.personArray,
  });
};

const deleteFromPersonArray = (state, action) => {
  return updateObject(state, {
    personArray: action.personArray,
  });
};

const setPersonArray = (state, action) => {
  return updateObject(state, {
    personArray: action.personArray,
  });
};

const setPersonSelectFieldList = (state, action) => {
  return updateObject(state, {
    personSelectFieldList: action.personSelectFieldList,
  });
};

const setPersonTextFieldList = (state, action) => {
  return updateObject(state, {
    personTextFieldList: action.personTextFieldList,
  });
};

//--------------------------------------------------------------------------------------
const addToPropertyArray = (state, action) => {
  return updateObject(state, {
    propertyArray: action.propertyArray,
  });
};

const deleteFromPropertyArray = (state, action) => {
  return updateObject(state, {
    propertyArray: action.propertyArray,
  });
};

const setPropertyArray = (state, action) => {
  return updateObject(state, {
    propertyArray: action.propertyArray,
  });
};

const setPropertySelectFieldList = (state, action) => {
  return updateObject(state, {
    propertySelectFieldList: action.propertySelectFieldList,
  });
};

const setPropertyTextFieldList = (state, action) => {
  return updateObject(state, {
    propertyTextFieldList: action.propertyTextFieldList,
  });
};

//--------------------------------------------------------------------------------------
const addToVehicleArray = (state, action) => {
  if (doLog())
    console.log("[addToVehicleArray reducers] array:", action.vehicleArray);
  return updateObject(state, {
    vehicleArray: action.vehicleArray,
  });
};

const deleteFromVehicleArray = (state, action) => {
  return updateObject(state, {
    vehicleArray: action.vehicleArray,
  });
};

const setVehicleArray = (state, action) => {
  return updateObject(state, {
    vehicleArray: action.vehicleArray,
  });
};

const setVehicleSelectFieldList = (state, action) => {
  return updateObject(state, {
    vehicleSelectFieldList: action.vehicleSelectFieldList,
  });
};

const setVehicleTextFieldList = (state, action) => {
  return updateObject(state, {
    vehicleTextFieldList: action.vehicleTextFieldList,
  });
};

//--------------------------------------------------------------------------------------
const fetchReportListStart = (state, action) => {
  return updateObject(state, {
    reportList: null,
    reportListLoading: true,
    reportListErrorMsg: "",
  });
};

const fetchReportListSuccess = (state, action) => {
  return updateObject(state, {
    reportList: action.reportList,
    reportListLoading: false,
    reportListErrorMsg: "",
  });
};

const fetchReportListFail = (state, action) => {
  if (doLog())
    console.log("[fetchReportListFail] action.ErrorMsg:", action.ErrorMsg);
  return updateObject(state, {
    reportList: null,
    reportListLoading: false,
    reportListErrorMsg: action.ErrorMsg,
  });
};

//--------------------------------------------------------------------------------------
const runReportStart = (state, action) => {
  return updateObject(state, {
    reportError: null,
    loading: true,
  });
};

const runReportSuccess = (state, action) => {
  // if (doLog()) console.log('transactions_reducer.runReportSuccess result:', action.result);
  return updateObject(state, {
    reportResult: action.reportResult,
    reportError: null,
    loading: false,
  });
};

const runReportFail = (state, action) => {
  return updateObject(state, {
    reportResult: null,
    reportError: action.reportError,
    loading: false,
  });
};

const clearReportResult = (state, action) => {
  return updateObject(state, {
    reportResult: null,
    reportError: null,
    loading: false,
  });
};

//--------------------------------------------------------------------------------------
const upLoadFileStart = (state, action) => {
  return updateObject(state, {
    upLoadFileError: null,
    loading: true,
  });
};

const upLoadFileSuccess = (state, action) => {
  // if (doLog()) console.log('transactions_reducer.upLoadFileSuccess result:', action.result);
  return updateObject(state, {
    upLoadFileResult: action.upLoadFileResult,
    upLoadNextIndex: action.upLoadNextIndex,
    upLoadFileError: null,
    loading: false,
  });
};

const upLoadFileFail = (state, action) => {
  return updateObject(state, {
    upLoadFileResult: null,
    upLoadFileError: action.upLoadFileError,
    loading: false,
  });
};

const upLoadClearResult = (state, action) => {
  return updateObject(state, {
    upLoadNextIndex: action.upLoadNextIndex,
    upLoadFileResult: action.upLoadFileResult,
    upLoadFileError: action.upLoadFileError,
  });
};

//--------------------------------------------------------------------------------------
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.TRANSACTION_START:
      return runTransactionStart(state, action);
    case actionTypes.TRANSACTION_SUCCESS:
      return runTransactionSuccess(state, action);
    case actionTypes.TRANSACTION_FAIL:
      return runTransactionFail(state, action);
    //
    case actionTypes.FETCH_INCIDENTTYPE_LIST_START:
      return fetchIncidentTypeListStart(state, action);
    case actionTypes.FETCH_INCIDENTTYPE_LIST_SUCCESS:
      return fetchIncidentTypeListSuccess(state, action);
    case actionTypes.FETCH_INCIDENTTYPE_LIST_FAIL:
      return fetchIncidentTypeListFail(state, action);
    // case actionTypes.STORE_INCIDENTTYPE_LIST_SELECTION: return storeIncidentTypeSelection(state, action);
    //
    case actionTypes.CLEAR_TRANSACTION_RESULT:
      return clearTransactionResult(state, action);
    case actionTypes.CLEAR_TRANS_DESC:
      return clearTransDesc(state, action);
    //
    case actionTypes.FETCH_CONFIGURATION_START:
      return fetchConfigurationStart(state, action);
    case actionTypes.FETCH_CONFIGURATION_SUCCESS:
      return fetchConfigurationSuccess(state, action);
    case actionTypes.FETCH_CONFIGURATION_FAIL:
      return fetchConfigurationFail(state, action);
    case actionTypes.SET_CONFIGURATION_DEFAULTS:
      return setConfigurationDefaults(state, action);
    case actionTypes.SET_AGENCYCODE:
      return setAgencyCode(state, action);
    case actionTypes.SET_SERVERINFO:
      return setServerInfo(state, action);
    //
    case actionTypes.CLEAR_VALIDCODE_LIST:
      return clearValidCodeList(state, action);
    case actionTypes.FETCH_VALIDCODE_LISTS_START:
      return fetchValidCodeListsStart(state, action);
    case actionTypes.FETCH_VALIDCODE_LISTS_SUCCESS:
      return fetchValidCodeListsSuccess(state, action);
    case actionTypes.FETCH_VALIDCODE_LISTS_FAIL:
      return fetchValidCodeListsFail(state, action);
    //
    case actionTypes.FETCH_MULTIPLE_VALIDCODE_LISTS_START:
      return fetchMultipleValidCodeListsStart(state, action);
    case actionTypes.FETCH_MULTIPLE_VALIDCODE_LISTS_SUCCESS:
      return fetchMultipleValidCodeListsSuccess(state, action);
    case actionTypes.FETCH_MULTIPLE_VALIDCODE_LISTS_FAIL:
      return fetchMultipleValidCodeListsFail(state, action);
    //
    case actionTypes.ADD_TO_CUSTOMTEXT_ARRAY:
      return addToCustomTextArray(state, action);
    case actionTypes.SET_CUSTOMTEXT_ARRAY:
      return setCustomTextArray(state, action);
    case actionTypes.CLEAR_CUSTOMTEXT_LIST:
      return clearCustomTextList(state, action);
    case actionTypes.FETCH_CUSTOMTEXT_LIST_START:
      return fetchCustomTextListStart(state, action);
    case actionTypes.FETCH_CUSTOMTEXT_LIST_SUCCESS:
      return fetchCustomTextListSuccess(state, action);
    case actionTypes.FETCH_CUSTOMTEXT_LIST_FAIL:
      return fetchCustomTextListFail(state, action);
    //
    case actionTypes.CLEAR_INCIDENT_DETAILS:
      return clearIncidentDetails(state, action);
    case actionTypes.FETCH_INCIDENT_DETAILS_START:
      return fetchIncidentDetailsStart(state, action);
    case actionTypes.FETCH_INCIDENT_DETAILS_SUCCESS:
      return fetchIncidentDetailsSuccess(state, action);
    case actionTypes.FETCH_INCIDENT_DETAILS_FAIL:
      return fetchIncidentDetailsFail(state, action);
    case actionTypes.SET_SHARED_INCIDENT_DETAILS:
      return setSharedIncidentDetails(state, action);
    //
    case actionTypes.ADD_TO_REQUIREDFIELD_ARRAY:
      return addToRequiredFieldArray(state, action);
    case actionTypes.SET_REQUIREDFIELD_ARRAY:
      return setRequiredFieldArray(state, action);
    case actionTypes.CLEAR_REQUIREDFIELD_LIST:
      return clearRequiredFieldList(state, action);
    case actionTypes.FETCH_REQUIREDFIELD_LIST_START:
      return fetchRequiredFieldListStart(state, action);
    case actionTypes.FETCH_REQUIREDFIELD_LIST_SUCCESS:
      return fetchRequiredFieldListSuccess(state, action);
    case actionTypes.FETCH_REQUIREDFIELD_LIST_FAIL:
      return fetchRequiredFieldListFail(state, action);
    //
    case actionTypes.FETCH_DEFAULTREQUIREDFIELD_LIST_START:
      return fetchDefaultRequiredFieldListStart(state, action);
    case actionTypes.FETCH_DEFAULTREQUIREDFIELD_LIST_SUCCESS:
      return fetchDefaultRequiredFieldListSuccess(state, action);
    case actionTypes.FETCH_DEFAULTREQUIREDFIELD_LIST_FAIL:
      return fetchDefaultRequiredFieldListFail(state, action);
    //
    case actionTypes.SET_INCIDENTTYPEDATA:
      return setIncidentTypeData(state, action);
    //
    case actionTypes.ADD_TO_ATTACHMENT_ARRAY:
      return addToAttachmentArray(state, action);
    case actionTypes.DELETE_FROM_ATTACHMENT_ARRAY:
      return deleteFromAttachmentArray(state, action);
    case actionTypes.SET_ATTACHMENT_ARRAY:
      return setAttachmentArray(state, action);
    case actionTypes.SET_ATTACHMENT_SELECT_FIELDLIST:
      return setAttachmentSelectFieldList(state, action);
    case actionTypes.SET_ATTACHMENT_TEXT_FIELDLIST:
      return setAttachmentTextFieldList(state, action);
    //
    case actionTypes.ADD_TO_PERSON_ARRAY:
      return addToPersonArray(state, action);
    case actionTypes.DELETE_FROM_PERSON_ARRAY:
      return deleteFromPersonArray(state, action);
    case actionTypes.SET_PERSON_ARRAY:
      return setPersonArray(state, action);
    case actionTypes.SET_PERSON_SELECT_FIELDLIST:
      return setPersonSelectFieldList(state, action);
    case actionTypes.SET_PERSON_TEXT_FIELDLIST:
      return setPersonTextFieldList(state, action);
    //
    case actionTypes.ADD_TO_PROPERTY_ARRAY:
      return addToPropertyArray(state, action);
    case actionTypes.DELETE_FROM_PROPERTY_ARRAY:
      return deleteFromPropertyArray(state, action);
    case actionTypes.SET_PROPERTY_ARRAY:
      return setPropertyArray(state, action);
    case actionTypes.SET_PROPERTY_SELECT_FIELDLIST:
      return setPropertySelectFieldList(state, action);
    case actionTypes.SET_PROPERTY_TEXT_FIELDLIST:
      return setPropertyTextFieldList(state, action);
    //
    case actionTypes.ADD_TO_VEHICLE_ARRAY:
      return addToVehicleArray(state, action);
    case actionTypes.DELETE_FROM_VEHICLE_ARRAY:
      return deleteFromVehicleArray(state, action);
    case actionTypes.SET_VEHICLE_ARRAY:
      return setVehicleArray(state, action);
    case actionTypes.SET_VEHICLE_SELECT_FIELDLIST:
      return setVehicleSelectFieldList(state, action);
    case actionTypes.SET_VEHICLE_TEXT_FIELDLIST:
      return setVehicleTextFieldList(state, action);
    //
    case actionTypes.FETCH_REPORT_LIST_START:
      return fetchReportListStart(state, action);
    case actionTypes.FETCH_REPORT_LIST_SUCCESS:
      return fetchReportListSuccess(state, action);
    case actionTypes.FETCH_REPORT_LIST_FAIL:
      return fetchReportListFail(state, action);
    //
    case actionTypes.REPORT_START:
      return runReportStart(state, action);
    case actionTypes.REPORT_SUCCESS:
      return runReportSuccess(state, action);
    case actionTypes.REPORT_FAIL:
      return runReportFail(state, action);
    case actionTypes.CLEAR_REPORT_RESULT:
      return clearReportResult(state, action);
    //
    case actionTypes.UPLOAD_FILE_START:
      return upLoadFileStart(state, action);
    case actionTypes.UPLOAD_FILE_SUCCESS:
      return upLoadFileSuccess(state, action);
    case actionTypes.UPLOAD_FILE_FAIL:
      return upLoadFileFail(state, action);
    case actionTypes.CLEAR_UPLOAD_RESULT:
      return upLoadClearResult(state, action);
    //
    case actionTypes.CLEAR_WEBAGENCY_LIST:
      return clearWebAgencyList(state, action);
    //
    default:
      return state;
  }
};

export default reducer;
